(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const split = value => String(value || '').split(/\s+/).filter(Boolean);
  const make = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };
  const validFavorites = value => Array.isArray(value) ? [...new Set(value.filter(x => typeof x === 'string' && /^[a-z0-9-]{1,50}$/.test(x)))].slice(0,300) : [];
  const storageKey = 'universo-turron-favoritos-v1';
  let favorites = [];
  let storageAvailable = true;
  try { favorites = validFavorites(JSON.parse(localStorage.getItem(storageKey) || '[]')); } catch (_) { storageAvailable = false; }
  document.querySelectorAll('[data-ut-root]').forEach(root => {
    if (root.dataset.utReady) return;
    root.dataset.utReady = 'true';
    root.querySelectorAll('[data-ut-enhanced]').forEach(el => { el.hidden = false; });
    const cards = [...root.querySelectorAll('[data-ut-list] [data-ut-card]')];
    const search = root.querySelector('[data-ut-search]');
    const controls = [...root.querySelectorAll('[data-ut-filter]')];
    const count = root.querySelector('[data-ut-count]');
    const empty = root.querySelector('[data-ut-empty]');
    const status = root.querySelector('[data-ut-status]');
    const favoriteToggle = root.querySelector('[data-ut-favorites]');
    const shareFallback = root.querySelector('[data-ut-share-fallback]');
    const nameSuggestions = root.querySelector('[data-ut-name-suggestions]');
    let suggestionNames = [];
    try { const data = root.querySelector('[data-ut-name-catalog]'); if (data) suggestionNames = JSON.parse(data.textContent).flat(); } catch (_) {}
    const namesById = new Map(suggestionNames.map(n => [n.id,n]));
    const savedTray = root.querySelector('[data-ut-saved-tray]');
    const savedList = root.querySelector('[data-ut-saved-list]');
    const practice = root.querySelector('[data-ut-name-practice]');
    const namePages = root.querySelector('[data-ut-name-pages]');
    const nameResults = root.querySelector('[data-ut-name-results]');
    const smallNames = namePages && typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 700px)') : {matches:false};
    let namePage = 0;
    const namePageSize = () => smallNames.matches ? 6 : 12;
    if (nameResults) {
      cards.forEach(card => nameResults.append(card));
      root.querySelector('[data-ut-name-index]').hidden = true;
    }
    let nameLabels = {};
    try { const labels = root.querySelector('[data-ut-name-labels]'); if (labels) nameLabels = JSON.parse(labels.textContent); } catch (_) {}
    if (root.dataset.kind === 'names' && namesById.size) favorites = favorites.filter(id => namesById.has(id));
    let onlyFavorites = false;
    let randomPick;
    const readHash = () => new URLSearchParams(location.hash.slice(1));
    const track = (action, detail = {}) => {
      const payload = { action, content: root.dataset.current, ...detail };
      document.dispatchEvent(new CustomEvent('universo:interaction', { detail: payload }));
      try { if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('universo_interaction', payload); } catch (_) {}
    };
    const message = text => { if (status) status.textContent = text; };
    const saveFavorites = () => {
      try { localStorage.setItem(storageKey, JSON.stringify(favorites)); }
      catch (_) { storageAvailable = false; message('Este navegador no permite guardar datos. Tus favoritos estarán disponibles mientras mantengas esta página abierta.'); }
    };
    const updateFavoriteButtons = () => {
      root.querySelectorAll('[data-ut-favorite]').forEach(button => {
        const active = favorites.includes(button.dataset.utFavorite);
        const name = button.closest('[data-ut-card]').querySelector('span').textContent;
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', `${active ? 'Quitar' : 'Guardar'} ${name} ${active ? 'de' : 'en'} favoritos`);
        button.textContent = active ? (nameLabels.saved || 'Guardado · Quitar') : (nameLabels.save || 'A mi lista');
      });
      root.querySelectorAll('[data-ut-favorite-count]').forEach(el => { el.textContent = favorites.length; });
      if (favoriteToggle) favoriteToggle.setAttribute('aria-pressed', String(onlyFavorites));
      if (savedTray && savedList) {
        savedList.replaceChildren();
        favorites.forEach(id => {
          const n = namesById.get(id);
          if (!n) return;
          const item = make('li');
          const test = make('button','ut-quiet',`${nameLabels.try} ${n.name}`);
          test.type = 'button'; test.dataset.utTryName = id;
          const remove = make('button','ut-quiet',`${nameLabels.remove} ${n.name}`);
          remove.type = 'button'; remove.dataset.utRemoveFavorite = id;
          item.append(make('strong','',n.name),test,remove); savedList.append(item);
        });
        savedTray.hidden = !savedList.children.length;
      }
    };
    const updateHash = () => {
      const params = readHash();
      ['q','sex','style','color','size','theme','initial','minutes','places','difficulty','materials','reward','stage','only'].forEach(k => params.delete(k));
      if (search?.value.trim()) params.set('q',search.value.trim());
      controls.forEach(control => { if (control.value) params.set(control.dataset.utFilter, control.value); });
      if (onlyFavorites) params.set('only','favorites');
      const next = params.toString();
      history.replaceState(null, '', location.pathname + location.search + (next ? '#' + next : ''));
    };
    const filter = (write = true) => {
      const query = normalize(search?.value);
      const filters = Object.fromEntries(controls.map(c => [c.dataset.utFilter,c.value]));
      let visible = 0;
      cards.forEach(card => {
        let matches = !query || normalize(card.dataset.search).includes(query);
        if (onlyFavorites) matches = matches && favorites.includes(card.dataset.nameId);
        const tags = split(card.dataset.tags);
        Object.entries(filters).forEach(([key,value]) => {
          if (!value) return;
          if (root.dataset.kind === 'names') {
            matches = matches && (key === 'sex' ? card.dataset.sex === value || card.dataset.sex === 'unisex' : key === 'initial' ? normalize(card.dataset.search).startsWith(value) : tags.includes(value));
          } else if (key === 'minutes') matches = matches && Number(card.dataset.minutes) <= Number(value);
          else if (key === 'places') matches = matches && split(card.dataset.places).includes(value);
          else matches = matches && card.dataset[key] === value;
        });
        card.hidden = !matches;
        if (matches) visible++;
      });
      const matchedCards = cards.filter(c => !c.hidden);
      if (namePages) {
        const pages = Math.max(1,Math.ceil(matchedCards.length/namePageSize()));
        namePage = Math.min(namePage,pages-1);
        matchedCards.forEach((card,index) => { card.hidden = index < namePage*namePageSize() || index >= (namePage+1)*namePageSize(); });
        namePages.querySelector('[data-ut-previous]').disabled = namePage === 0;
        namePages.querySelector('[data-ut-next]').disabled = namePage >= pages-1;
        namePages.querySelector('[data-ut-page-status]').textContent = nameLabels.page.replace('{page}',namePage+1).replace('{pages}',pages);
        namePages.hidden = matchedCards.length <= namePageSize();
      }
      let matchingNames = [];
      if (nameSuggestions) {
        nameSuggestions.replaceChildren();
        matchingNames = query ? suggestionNames.filter(n => normalize(n.name).includes(query)) : [];
        matchingNames.slice(0,8).forEach(n => {
          const link=make('a','',`${n.name} · Ver nombre ↗`);
          const target=new URL(nameSuggestions.dataset.target,location.href);target.hash=new URLSearchParams({q:n.name}).toString();link.href=target.href;nameSuggestions.append(link);
        });
      }
      const nouns = root.dataset.kind === 'names' ? ['nombre','nombres'] : root.dataset.kind === 'breeds' ? ['raza','razas'] : root.dataset.kind === 'activities' ? ['juego','juegos'] : root.dataset.kind === 'adoption' ? ['guía','guías'] : ['contenido','contenidos'];
      if (count) count.textContent = `${visible} ${nouns[visible === 1 ? 0 : 1]} en esta selección${matchingNames.length ? ` · ${matchingNames.length} ${matchingNames.length === 1 ? 'nombre encontrado' : 'nombres encontrados'}` : ''}`;
      if (count && namePages && visible) count.textContent += ` · ${nameLabels.shown.replace('{count}',Math.min(namePageSize(),visible-namePage*namePageSize()))}`;
      if (empty) empty.hidden = visible !== 0 || matchingNames.length !== 0;
      root.querySelector('.ut-search-section')?.classList.toggle('ut-searching', Boolean(query));
      const searchIndex = root.querySelector('[data-ut-search-index]');
      if (searchIndex) {
        searchIndex.open = Boolean(query);
        if (!query && count) count.textContent = `Busca entre ${cards.length} contenidos y ${suggestionNames.length} nombres.`;
      }
      if (write) updateHash();
      updateFavoriteButtons();
      return matchedCards;
    };
    const restore = () => {
      namePage = 0;
      const params = readHash();
      if (search) search.value = params.get('q') || '';
      controls.forEach(c => { const value = params.get(c.dataset.utFilter) || ''; c.value = [...c.options].some(o => o.value === value) ? value : ''; });
      onlyFavorites = params.get('only') === 'favorites';
      if (params.has('favs') && root.dataset.kind === 'names') {
        const allowed = namesById.size ? new Set(namesById.keys()) : new Set(cards.map(c => c.dataset.nameId));
        const shared = validFavorites(params.get('favs').split(',')).filter(id => allowed.has(id));
        if (shared.length) { favorites = shared; onlyFavorites = true; saveFavorites(); message(`Selección compartida: ${shared.length} nombres. Puedes quitar o añadir favoritos.`); }
      }
      filter(false);
    };
    search?.addEventListener('input', () => { namePage = 0; filter(); });
    controls.forEach(control => control.addEventListener('change', () => { namePage = 0; filter(); track('filter', { filter: control.dataset.utFilter }); }));
    root.querySelector('[data-ut-reset]')?.addEventListener('click', () => {
      if (search) search.value = '';
      controls.forEach(c => { c.value = ''; });
      onlyFavorites = false;
      namePage = 0;
      if (randomPick) randomPick.classList.remove('ut-picked');
      const params = readHash(); params.delete('favs'); history.replaceState(null,'',location.pathname+location.search+(params.size?'#'+params:''));
      message(''); filter(); search?.focus();
    });
    favoriteToggle?.addEventListener('click', () => {
      onlyFavorites = !onlyFavorites; namePage = 0; filter();
      if (!savedTray?.hidden) savedTray.scrollIntoView({block:'start',behavior:smallNames.matches?'auto':'smooth'});
      track('show_favorites');
    });
    const changeNamePage = delta => {
      namePage = Math.max(0,namePage+delta); filter(false);
      root.querySelector('[data-ut-name-results-title]')?.focus({preventScroll:true});
      nameResults?.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      track('names_page',{page:namePage+1});
    };
    namePages?.querySelector('[data-ut-previous]').addEventListener('click', () => changeNamePage(-1));
    namePages?.querySelector('[data-ut-next]').addEventListener('click', () => changeNamePage(1));
    smallNames.addEventListener?.('change', () => { namePage = 0; filter(false); });
    root.addEventListener('click', event => {
      const test = event.target.closest('[data-ut-try-name]');
      if (test && practice) {
        const n = namesById.get(test.dataset.utTryName);
        if (!n) return;
        practice.querySelector('[data-ut-practice-title]').textContent = nameLabels.practice.replace('{name}',n.name);
        const phrases = practice.querySelector('[data-ut-practice-phrases]'); phrases.replaceChildren();
        [`Hola, ${n.name}.`,`Vamos, ${n.name}.`,`${n.name}, ven.`].forEach(text => phrases.append(make('li','',text)));
        practice.hidden = false; practice.focus({preventScroll:true});
        practice.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        track('try_name');
      }
      const remove = event.target.closest('[data-ut-remove-favorite]');
      if (remove) {
        const index = favorites.indexOf(remove.dataset.utRemoveFavorite);
        favorites = favorites.filter(id => id !== remove.dataset.utRemoveFavorite);
        const hash = readHash(); hash.delete('favs'); history.replaceState(null,'',location.pathname+location.search+(hash.size?'#'+hash:''));
        saveFavorites(); filter();
        const remaining = [...savedList.querySelectorAll('[data-ut-remove-favorite]')];
        (remaining[Math.min(index,remaining.length-1)] || favoriteToggle)?.focus({preventScroll:true});
        track('favorite',{count:favorites.length});
      }
    });
    root.querySelectorAll('[data-ut-favorite]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.utFavorite;
      favorites = favorites.includes(id) ? favorites.filter(x => x !== id) : [...favorites,id];
      const hash = readHash(); hash.delete('favs'); history.replaceState(null,'',location.pathname+location.search+(hash.size?'#'+hash:''));
      saveFavorites(); filter(); track('favorite', { count: favorites.length });
    }));
    root.querySelector('[data-ut-random]')?.addEventListener('click', () => {
      const visible = filter(false);
      if (!visible.length) { message('Amplía los filtros para poder sorprenderte.'); return; }
      if (randomPick) randomPick.classList.remove('ut-picked');
      randomPick = visible[Math.floor(Math.random()*visible.length)];
      if (namePages && randomPick.hidden) { namePage = Math.floor(visible.indexOf(randomPick)/namePageSize()); filter(false); }
      randomPick.classList.add('ut-picked');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      randomPick.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block:'center' });
      randomPick.querySelector('button')?.focus({ preventScroll:true });
      message(`¿Qué te parece ${randomPick.querySelector('span').textContent}?`); track('random_name');
    });
    const listURL = () => {
      const target = new URL(root.querySelector('[data-ut-share-base]')?.dataset.utShareBase || location.href,location.href);
      if (new URLSearchParams(target.search).get('view')?.startsWith('ut-')) target.searchParams.set('view','ut-nombres-para-perros');
      else target.pathname = '/pages/nombres-para-perros';
      target.hash = new URLSearchParams({ favs: favorites.join(','), only:'favorites' }).toString();
      return target;
    };
    root.querySelector('[data-ut-download]')?.addEventListener('click', () => {
      if (!favorites.length) return;
      const text = [nameLabels.downloadTitle,'',...favorites.map(id => namesById.get(id)?.name).filter(Boolean),'',listURL().href].join('\n');
      const url = URL.createObjectURL(new Blob([text],{type:'text/plain;charset=utf-8'}));
      const link = make('a');link.href=url;link.download='mi-lista-de-nombres-turron.txt';link.hidden=true;root.append(link);link.click();link.remove();
      setTimeout(() => URL.revokeObjectURL(url),1000);
      message('Lista descargada. Incluye los nombres y el enlace para recuperarla.');track('download_names',{count:favorites.length});
    });
    root.querySelector('[data-ut-share]')?.addEventListener('click', async () => {
      if (!favorites.length) { message('Añade al menos un nombre a tu lista para compartirla.'); return; }
      const target = listURL();
      try {
        if (navigator.share) await navigator.share({ title:'Nuestros nombres favoritos · Universo Turrón', url:target.href });
        else if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(target.href); message('Enlace copiado. Comparte vuestra lista de favoritos.'); }
        else throw new Error('clipboard unavailable');
        track('share_favorites', { count:favorites.length });
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (shareFallback) { shareFallback.hidden = false; const input = shareFallback.querySelector('input'); input.value = target.href; input.focus(); input.select(); message('Copia el enlace para compartir la selección.'); }
      }
    });
    window.addEventListener('storage', event => { if (event.key === storageKey) { try { favorites = validFavorites(JSON.parse(event.newValue || '[]')); filter(false); } catch (_) {} } });
    window.addEventListener('hashchange',restore);
    restore();
    const photoCredits = root.querySelector('#ut-photo-credits');
    root.querySelectorAll('a[href="#ut-photo-credits"]').forEach(link => link.addEventListener('click', event => {
      if (!photoCredits) return;
      event.preventDefault();
      photoCredits.open = true;
      photoCredits.querySelector('summary')?.focus({ preventScroll: true });
      photoCredits.scrollIntoView({ block: 'start' });
      history.replaceState(null, '', location.pathname + location.search + '#ut-photo-credits');
    }));
    if (photoCredits && location.hash === '#ut-photo-credits') photoCredits.open = true;
    root.querySelectorAll('[data-ut-checklist]').forEach(section => {
      const key = 'universo-turron-bienvenida-v1';
      const checks = [...section.querySelectorAll('[data-ut-check]')];
      const ids = new Set(checks.map(input => input.dataset.utCheck));
      const progress = section.querySelector('progress');
      const label = section.querySelector('[data-ut-check-count]');
      const notice = section.querySelector('[data-ut-check-status]');
      const clean = value => Array.isArray(value) ? [...new Set(value.filter(id => ids.has(id)))] : [];
      let completed = [];
      let canSave = true;
      try { completed = clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch (_) { canSave = false; }
      const update = () => {
        checks.forEach(input => { input.checked = completed.includes(input.dataset.utCheck); });
        if (progress) { progress.max = checks.length; progress.value = completed.length; }
        if (label) label.textContent = `${completed.length} de ${checks.length}`;
        if (notice) notice.textContent = canSave ? `${completed.length} de ${checks.length} preparativos completados. Guardado en este navegador.` : 'Puedes usar la lista en esta página, pero este navegador no permite conservar el progreso.';
      };
      const save = () => {
        try { localStorage.setItem(key,JSON.stringify(completed)); canSave = true; } catch (_) { canSave = false; }
        update();
      };
      checks.forEach(input => input.addEventListener('change', () => {
        completed = checks.filter(item => item.checked).map(item => item.dataset.utCheck);
        save(); track('arrival_checklist', { count: completed.length });
      }));
      section.querySelector('[data-ut-check-reset]')?.addEventListener('click', () => { completed = []; save(); track('arrival_reset'); });
      section.querySelector('[data-ut-print]')?.addEventListener('click', () => { track('arrival_print'); window.print(); });
      window.addEventListener('storage', event => {
        if (event.key !== key) return;
        try { completed = clean(JSON.parse(event.newValue || '[]')); update(); } catch (_) {}
      });
      update();
    });
    if (!storageAvailable && root.dataset.kind === 'names') message('Tus favoritos funcionan en esta página, pero este navegador no permite conservarlos al cerrarla.');
    root.querySelectorAll('[data-ut-compare]').forEach(section => {
      let data;
      try { data = JSON.parse(section.querySelector('[data-ut-breeds]').textContent); } catch (_) { return; }
      const selects = [...section.querySelectorAll('[data-ut-compare-select]')];
      const output = section.querySelector('[data-ut-comparison]');
      const params = readHash();
      const selectedIds = (params.get('compare') || '').split(',');
      selects.forEach((select,i) => { if (data.some(x => x.id === selectedIds[i])) select.value = selectedIds[i]; });
      if (selects[0].value === selects[1].value) selects[1].value = data.find(x => x.id !== selects[0].value).id;
      const render = (write = true) => {
        const breeds = selects.map(s => data.find(b => b.id === s.value));
        output.replaceChildren();
        if (breeds[0].id === breeds[1].id) { output.append(make('p','ut-compare-notice','Has elegido la misma raza dos veces. Cambia una para ver sus diferencias.')); return; }
        const grid = make('div','ut-compare-grid');
        breeds.forEach(b => { const cell=make('div','ut-compare-cell');const img=make('img');img.src=b.image;img.alt=b.name;img.width=500;img.height=300;img.loading='lazy';cell.append(img,make('h3','',b.name));const link=make('a','', 'Leer la ficha ↗');link.href=b.url;cell.append(link);grid.append(cell); });
        [['size','Referencia de tamaño'],['coat','Pelo'],['grooming','Mantenimiento'],['activity','Actividad orientativa'],['home','Convivencia cotidiana']].forEach(([key,label]) => breeds.forEach(b => {const dl=make('dl','ut-compare-cell');dl.append(make('dt','',label),make('dd','',b[key]));grid.append(dl);}));
        output.append(grid);
        if (write) { const hash=readHash();hash.set('compare',breeds.map(b=>b.id).join(','));history.replaceState(null,'',location.pathname+location.search+'#'+hash);track('compare_breeds'); }
      };
      selects.forEach(s => s.addEventListener('change', () => render())); render(false);
    });
    root.querySelectorAll('[data-ut-product]').forEach(link => link.addEventListener('click', () => track('product_click',{product:link.dataset.utProduct})));
    if (root.querySelector('.ut-game-article')) {
      let closedBeforePrint = [];
      window.addEventListener('beforeprint', () => {
        closedBeforePrint = [...root.querySelectorAll('.ut-faq details:not([open])')];
        closedBeforePrint.forEach(details => { details.open = true; });
      });
      window.addEventListener('afterprint', () => {
        closedBeforePrint.forEach(details => { details.open = false; });
        closedBeforePrint = [];
      });
    }
    root.querySelector('[data-ut-game-print]')?.addEventListener('click', () => { track('game_print'); window.print(); });
  });
})();
